<template>
    <section class="content">
      <box>
        <div slot="body">
            <div class="row">
              <div class="col-md-6">
                  <h4>Nome</h4>
                  <input v-model="nome" type="text" class="form-control" >
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <h4>Imagem </h4>
                <input type="file" id="file-input" class="form-control">
                <p id="status">Please select a file</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <h4>Ativo</h4><br>
                <toggle-button 
                  v-model="ativo"
                  :color="color" 
                  :sync="true" />
              </div>
              <div class="col-md-2">
                <h4>Habilita multiplo sabor (Pizza)</h4>
                <toggle-button 
                  v-model="permitemeia"
                  :color="color" 
                  :sync="true" />
              </div>
              <div class="col-md-2">
                <h4>Categoria de Produtos Adicionais</h4>
                <toggle-button 
                  v-model="adicionais"
                  :color="color" 
                  :sync="true" />
              </div>
              
            </div>
            <br>
            <!--    SUBNIVEL   -->
            <!--<div class="row">
              <div class="col-md-12">
                <label class="btn btn-secondary">
                  <input type="checkbox" v-model="subnivel" > Cadastrar como Subnivel
                </label>
              </div>
            </div>
            <div class="row" v-show="subnivel" >
              <div class="col-md-12">
              <h4>Categoria Pai</h4>
                <select class="form-control" v-model="categoria_pai">
                    <option v-for="c in categories" v-bind:value="c.id">{{c.id}} - {{c.nome}}</option>
                </select>
              </div>
            </div>-->
            <br><br>
            <router-link class="pageLink" to="/categorias">
                    <button class="btn btn-danger" >Cancelar</button>
            </router-link>
            <button class="btn btn-success" @click="gravar" v-show="nome!='' && !gravando"><i class="fa fa-check"></i>  Gravar</button>
            <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
            <!-- <canvas id="canvas"></canvas>
            <img src="" alt="" id="preview"> -->
        </div>
    </box>
        
    </section>
</template>
<script>
import axios from 'axios'
import Box from './Box' // importando modal
import s3 from '../../services/s3'

export default {
  name: 'NovaCategoria',
  components: {
    'box': Box
  },
  data () {
    return {
      nome: '',
      allCategories: [],
      categories: [],
      categoria_pai: null,
      subnivel: false,
      gravando: false,
      imagem: '',
      editar: false,
      permitemeia: false,
      adicionais: false,
      ativo: true,
    }
  },
  created () {
    if(this.$route.params.id) {
      this.getCategoriaById(this.$route.params.id)
      this.editar = true
    }
    // let ckeditor = document.createElement('script');    
    // ckeditor.setAttribute('src',"https://compressjs.herokuapp.com/compress.js");
    // document.head.appendChild(ckeditor);
  },
  methods: {
    async gravar () {
      this.gravando = true
      const files = document.getElementById('file-input').files;
      const file = files[0];

      if(file != null) {
        var blob = file.slice(0, file.size, file.type); 
        console.log('blob => ', blob)
        let newFile = new File([blob], `${this.$store.state.empresa_id}_categoria_${Date.now()}_${file.name.replace(' ', '_')}`, {type: file.type});

        // console.log('new file ==> ', newFile)
        // let imgTratada = await this.tratamentoImagem(newFile);

        s3.getSignedRequest(newFile).then(res => {
          this.imagem = res.url
          this.gravarCategoria();
        }).catch(err => {
          console.log(err)
          alert('Erro ao salvar imagem');
        })
      } else {
        if(this.editar) {
          this.gravarCategoria();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.gravando = false
        }
      }
    },
    gravarCategoria(){
      axios.post(this.$store.state.api+'categorias/insert', {
        'nome': this.nome,
        //'pai': this.categoria_pai,
        'imagem': this.imagem,
        'alteracao': this.editar,
        'id_categoria': this.$route.params.id,
        'permitemeia' : this.permitemeia,
        'adicionais' : this.adicionais,
        'ativo': this.ativo,
        'empresa': this.$store.state.empresa_fb_id
      }).then(response => {
          if (response.data.success) {
            this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Criada com sucesso',
                    showConfirmButton: false,
                    timer: 1500
                  })   
            this.$router.go(-1)
          } else {
            this.$swal(
              'Ops!',
              'A categoria não foi gravada.',
              'error'
            )
          }
        })
    },
    getCategoriaById (id) {
      axios.get(this.$store.state.api + 'categorias/' + id).then((response) => {
        console.log('categorias -> ', response.data)
        this.nome = response.data.nome,
        this.imagem = response.data.url_imagem
        this.permitemeia = response.data.permite_meia
        this.adicionais = response.data.adicionais
        this.ativo = response.data.ativo
      }) 
    }
  }
}
</script>



// WEBPACK FOOTER //
// NovaCategoria.vue?9d1ffaf8